module.exports = __webpack_public_path__ + "static/media/linear-hospital.82cf50b6.svg";